import { AssignorCreationAccount } from './accounts.model';
import { FundCertifier } from './certifier.model';
import { ReducedFundData } from './fund.model';
import { AssignorGuarantors } from './guarantors.model';
import { SelectData } from './select-input.model';

export interface Operation {
  arquivo: OperationFile;
  cedente: ReducedFundData;
  dataAssinatura: string;
  dataEntradaArquivo: string;
  dataPagamento: string;
  fundo: ReducedFundData;
  idOperacaoRecebivel: number;
  quantidadeTitulos: number;
  status: OperationStatus;
  taxaCessao: number;
  tedCedenteDouble: number;
  totalAquisicaoDouble: number;
  totalNominalDouble: number;
  totalRecompraDouble: number;
  valorReembolso: number;
}

export interface OperationTable {
  id: number;
  cedente: string;
  fundo: string;
  valorNominal: number;
  valorAquisicao: number;
  taxaCessao: number;
  status: string;
  nomeArquivo: string;
  valorRecompra: number;
  valorTotalTed: number;
  quantidadeTitulos: number;
  dataEntradaArquivo: string;
  arquivo: string;
}

export interface OperationDetailDialog extends OperationTable {
  avalistas: SelectData[];
  dadosBancarios: SelectData[];
  certificadoras: SelectData[];
  reembolsoDespesas: number;
  certificadora: string;
  contaCorrente: string;
}

interface OperationFile {
  nM_ARQUIVO: string;
  nM_ARQUIVO_ENTRADA: string;
}

export interface BaseModel {
  code: number;
  succes: boolean;
  model: OperationStatus[];
}

export interface OperationStatus {
  id: number;
  codigo: string;
  nome: string;
  situacao: string;
}

export interface OperationSearchParams {
  fundos?: ReducedFundData[];
  status?: OperationStatus[];
  tipoRecebiveis?: string[];
  cnpjFundos?: string[];
  data?: string;
}

export interface OperationsDetail {
    data: {
      id: number;
      cedente: {
        avalistas: AssignorGuarantors[];
        dadosBancarios: AssignorCreationAccount[];
      };
      fundo: {
        certificadoras: FundCertifier[];
      };
      dataOperacao: string;
      reembolsoDespesas: number;
      contaCorrente: string;
      certificadora: {
        nomeCertificadora: string;
      };
    };
}

export interface OperationApproval {
  idOperacaoRecebivel: number,
  idContaCorrente: number,
  idCertificadora: number,
  idsAvalistas: number[],
  valorReembolso: number,
  usuario: string,
  origem: number,
}

export interface OperationDissaproval {
  id: number,
  justification: string,
  usuario: string,
  origem: number,
}

export interface ManagerApproval {
  idOperacaoRecebivel: number,
  usuario: string,
  origem: number,
}

export interface UpdateStatus {
  idOperacaoRecebivel: number;
  status: string;
  justificativa: string;
  usuario: string,
  origem: number,
}

export interface OperationCards {
  totalAquisicao: number;
  totalRecompra: number;
  reembolsoDespesas: number;
  pagoCedentes: number;
  totalRecebiveis: number;
  totalNominal: number;
}
